declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

const firedScrollDepths = new Set<number>();

export function trackEvent(eventName: string, params?: Record<string, string | number>) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }

  window.gtag('event', eventName, params);
}

export function trackDownloadClick(location: string) {
  trackEvent('click', {
    event_category: 'CTA',
    event_label: 'download_button',
    location,
  });
}

export function trackPricingView() {
  trackEvent('view_item_list', {
    event_category: 'Pricing',
    event_label: 'pricing_plan_view',
  });
}

export function trackScrollDepth() {
  if (typeof window === 'undefined') {
    return;
  }

  const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
  if (documentHeight <= 0) {
    return;
  }

  const depth = Math.round((window.scrollY / documentHeight) * 100);
  const milestones = [25, 50, 75, 100];

  milestones.forEach((milestone) => {
    if (depth >= milestone && !firedScrollDepths.has(milestone)) {
      firedScrollDepths.add(milestone);
      trackEvent('scroll', {
        event_category: 'Engagement',
        event_label: `scroll_${milestone}`,
        value: milestone,
      });
    }
  });
}
